
  window.ParsleyConfig = {
    // ### Field only
    // identifier used to group together inputs (e.g. radio buttons...)
    multiple: null,
    // identifier (or array of identifiers) used to validate only a select group of inputs
    group: null,
    // ### UI
    // Enable\Disable error messages
    uiEnabled: true,
    // Key events threshold before validation
    validationThreshold: 3,
    // Focused field on form validation error. 'first'|'last'|'none'
    focus: 'first',
    // `$.Event()` that will trigger validation. eg: `keyup`, `change`...
    trigger: 'blur',
    // Class that would be added on every failing validation Parsley field
    errorClass: 'input--invalid',
    // Same for success validation
    successClass: 'input--valid',
    // Return the `$element` that will receive these above success or error classes
    // Could also be (and given directly from DOM) a valid selector like `'#div'`
    classHandler: function (ParsleyField) {
      var $input = ParsleyField.$element.closest('.input');
      return $input.length ? $input : ParsleyField.$element;
    },
    // Return the `$element` where errors will be appended
    // Could also be (and given directly from DOM) a valid selector like `'#div'`
    errorsContainer: function (ParsleyField) {
      var $input = ParsleyField.$element.closest('.input');
      return $input.length ? $input : ParsleyField.$element.parent();
    },

    // ul elem that would receive errors' list
    errorsWrapper: '<dd class="input__errors"></dd>',

    // li elem that would receive error message
    errorTemplate: '<mark class="input__error"></mark>'
  };
